module.exports = __webpack_public_path__ + "static/media/19_AnnelieHegemann_webfinal.5e6bfdc4.jpg";